<ll-titulo>Crear escalas globales</ll-titulo>
<ll-toolnavbar></ll-toolnavbar>
<escala-globales-new></escala-globales-new>
